<ngx-slick-carousel class="carousel" [config]="slideConfig" #slickModal="slick-carousel">
  @for (slide of licenses; track slide) {
    <div ngxSlickItem class="slide">
      <bmcore-license-item
        [license]="slide"
        [licenseBulkDiscounts]="licenseBulkDiscounts"
        [btnInLicenseName]="btnInLicenseName"
        [toBeatListBtnRoute]="toBeatListBtnRoute"
      >
      </bmcore-license-item>
    </div>
  }
</ngx-slick-carousel>
